import * as types from '../types/profileType';

const initialState = {
	isOpenModal: false,
	isLoadingForm: false,
};

const profileReducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case types.IS_OPEN_MODAL_PROFILE:
			return {
				...state,
				isOpenModal: payload
			};

		case types.IS_LOADING_FORM_PROFILE:
			return {
				...state,
				isLoadingForm: payload
			};

		default:
			return state;
	}
};

export default profileReducer;
